<template>
  <v-col class="board__pending-actions">
    <BoardCardColumnTitle title="PENDING" clean />
    <BoardCardPending />
  </v-col>
</template>

<script>
import BoardCardPending from './pendingActions/BoardCardPending'
import BoardCardColumnTitle from './pendingActions/BoardColumnTitle'

export default {
  name: 'BoardPendingActions',

  components: {
    BoardCardPending,
    BoardCardColumnTitle,
  },
}
</script>
